import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-2xl mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6"
        >
          <ArrowLeft className="w-4 h-4" />
          Back
        </button>
        
        <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-gray-200">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">Terms of Use</h1>
          
          <div className="space-y-6 text-gray-700 text-sm md:text-base">
            <p>
              UniConnect is a student-built platform and is not affiliated with or endorsed by Toronto Metropolitan University.
            </p>

            <div>
              <h2 className="font-semibold text-gray-900 mb-2">User Responsibility</h2>
              <p>Use the platform respectfully. Do not post harmful or inappropriate content.</p>
            </div>

            <div>
              <h2 className="font-semibold text-gray-900 mb-2">Content</h2>
              <p>You are responsible for what you post.</p>
            </div>

            <div>
              <h2 className="font-semibold text-gray-900 mb-2">Accounts</h2>
              <p>You are responsible for your account.</p>
            </div>

            <div>
              <h2 className="font-semibold text-gray-900 mb-2">Platform Use</h2>
              <p>We may remove content or restrict users who violate rules.</p>
            </div>

            <div>
              <h2 className="font-semibold text-gray-900 mb-2">No Guarantee</h2>
              <p>The platform is provided as-is.</p>
            </div>

            <div>
              <h2 className="font-semibold text-gray-900 mb-2">Changes</h2>
              <p>These terms may be updated over time.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
